var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMaximizeCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/maximize-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "maximize-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3335 2H14.0002V4.66667",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10 6L14 2",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.66667 13.9997H2V11.333",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6 10L2 14",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.34684 1.46635C8.91351 1.37968 8.46016 1.33301 8.00016 1.33301C4.32016 1.33301 1.3335 4.31967 1.3335 7.99967C1.3335 8.45967 1.38017 8.90634 1.46684 9.33301",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M6.65332 14.5337C7.08665 14.6203 7.54 14.667 8 14.667C11.68 14.667 14.6667 11.6803 14.6667 8.00033C14.6667 7.54699 14.62 7.10033 14.5333 6.66699",
    stroke: "#173D33",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximizeCircle);
export default __webpack_public_path__ + "static/media/maximize-circle.ff885307167e1df664050ba7b8544c02.svg";
export { ForwardRef as ReactComponent };